import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 3}, 1fr);
  gap: ${props => props.gap || '20px'};
  width: 100%;

  @media(max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media(max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ProductGridWidget = ({ node }) => {
  const columns = node.style?.desktop?.columns || 3;
  const gap = node.style?.desktop?.gap || '20px';
  const count = node.content?.count || 6;

  // Lade Fake-Produkte
  const products = Array.from({ length: count }).map((_, i) => ({
    id: i,
    category: 'Zubehör',
    title: `Smart Product ${i+1}`,
    price: `€${(99 + i*15).toFixed(2)}`,
    image: `https://via.placeholder.com/300x300/0b1120/00A9E0?text=Prod+${i+1}`
  }));

  return (
    <GridWrapper columns={columns} gap={gap}>
      {products.map(p => (
        <div key={p.id} style={{
          background: 'var(--glass-1)', 
          border: '1px solid var(--glass-border)', 
          borderRadius: '12px',
          overflow: 'hidden',
          backdropFilter: 'blur(10px)'
        }}>
          <img src={p.image} alt={p.title} style={{width:'100%', height:'200px', objectFit:'cover'}} />
          <div style={{padding:'15px'}}>
            <div style={{fontSize:'10px', color:'var(--accent)', textTransform:'uppercase', fontWeight:'bold', marginBottom:'4px'}}>{p.category}</div>
            <div style={{fontSize:'16px', fontWeight:'bold', color:'var(--text-primary)', marginBottom:'10px'}}>{p.title}</div>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
              <div style={{fontWeight:'800', fontSize:'18px'}}>{p.price}</div>
              <button style={{
                background:'rgba(6,182,212,0.1)', color:'var(--accent)', border:'none', 
                borderRadius:'8px', padding:'6px 12px', cursor:'pointer', fontWeight:'bold'
              }}>Kaufen</button>
            </div>
          </div>
        </div>
      ))}
    </GridWrapper>
  );
};

registry.register('product_grid', {
  label: 'Produkt Raster',
  icon: '📱',
  category: 'ecommerce',
  defaultContent: { count: 3 },
  defaultStyle: { desktop: { columns: 3, gap: '20px' } },
  render: ProductGridWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Datenhaltung (Mock)', fields: [{name:'content.count', label:'Anzahl Dummy-Produkte', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Grid Layout', fields: [{name:'style.desktop.columns', label:'Spalten (Desktop)', type:'select', options:[{label:'2',value:2},{label:'3',value:3},{label:'4',value:4}]}, {name:'style.desktop.gap', label:'Abstand (Gap)', type:'text'}] }] }
  ]
});
